<template>
  <div class="mine-content">
    <div class="m-content">
      <div class="btn-group">
        <ChooseDirection :content="testPassages[0]" v-on:listenToChildEvent="prepareNext"></ChooseDirection>
        <ChooseValue :content="testPassages[1]" v-on:listenToChildEvent="prepareNext"></ChooseValue>
        <SetWeight :content="testPassages[2]" v-on:listenToChildEvent="prepareNext"></SetWeight>
        <SetScore v-for = "(item,index) in testPassages" :content="item" v-on:listenToChildEvent="prepareNext"></SetScore>
        <button class="default-btn large-btn" :class="show?'half-opacity':''" v-if="next" @click="ToNext">下一步</button>
        <button class="default-btn middle-btn" v-if="nextGroup" @click="ToPrev">上一步</button>
        <button class="default-btn middle-btn" :class="show?'half-opacity':''" v-if="nextGroup" @click="ToNext">下一步</button>
        <button class="default-btn large-btn submit-btn" v-if="submit" @click="submitDta" v-preventReClick>提交</button>
      </div>
    </div>
  </div>
</template>
<script>
import ChooseDirection from '../components/ChooseDirection.vue'
import ChooseValue from '../components/ChooseValue.vue'
import SetWeight from '../components/SetWeight.vue'
import SetScore from '../components/SetScore.vue'
import axios from 'axios'
import qs from 'qs'
import setWechatTitle from '@/utils/setWechatTitle.js'
import { mapState } from 'vuex'

export default {
  props:{
    id: Number
  },
  name:'DecisionMaking',
  components:{
    'ChooseDirection':ChooseDirection,
    'ChooseValue':ChooseValue,
    'SetWeight':SetWeight,
    'SetScore':SetScore
  },
  data(){
    return {
      testPassages:[
          {'num':1,'options':['国企','国内升学','外企','公务员','民企','出国留学','事业单位','灵活就业','创业','参军入伍','三支一扶','大学生志愿服务西部计划'],'type':1,'show':true,errorMessage:''},
          {'num':2,'option1':['收入高','福利好','工作稳定','工作环境好','工作单位地理位置不错','交通便利快捷','不经常出差和加班、休闲时间充分','工作中人际关系和谐'],'option2':['工作内容符合兴趣爱好','能够胜任、学以致用','能发挥自己的才能','工作机会均等、公平竞争','自主性大，不受约束','提供培训、继续教育等机会','工作内容具有一定挑战性','工作压力不大','工作内容多样丰富，不单调'],'option3':['单位知名度高','社会经济地位高','晋升机会多','单位规模大','易成名成家','单位在大城市','受人尊重','能够助人、为社会贡献'],'type':2,'show':false,errorMessage:''},
          {'num':3,'options':[],'type':3,'show':false},
          {'num':4,'direction':'','options':[],'type':4,'show':false},
          {'num':5,'direction':'','options':[],'type':4,'show':false},
          {'num':6,'direction':'','options':[],'type':4,'show':false}
        ],
      show:true,
      answerArray:['','','','','',''],
      current:1,
      currentAnswer:'',
      result:'',
      next:true,
      nextGroup:false,
      submit:false,
      submitNum:0
    }
  },
  computed: {
    ...mapState({
      shengyaUser: state => state.shengyaUser.userInfo,
    }),
  },
  created(){
    setWechatTitle('生涯驿站-我的决策产生记');
  },
  methods:{
    prepareNext(answer,num){
      if(answer){
        this.show=false
        this.current = num
        this.currentAnswer=''
        // 将结果进行暂存
        answer.map((item,index)=>{
          if(item.id){
            this.currentAnswer += item.id+'<'+item.answer
          }else{
            this.currentAnswer += (index+1)+'<'+item
          }
          if(index<answer.length-1){
            this.currentAnswer +=','
          }
        })
        this.answerArray[num-1] = this.currentAnswer;
        // 根据第1题设置4/5/6题的方向名,根据第2题设置4/5/6题的选项
        if(num==1){
          this.testPassages[num+2].direction=answer[0]
          this.testPassages[num+3].direction=answer[1]
          this.testPassages[num+4].direction=answer[2]
        }else if(num==2){
          this.testPassages[num].options=answer
          this.testPassages[num+1].options=answer
          this.testPassages[num+2].options=answer
          this.testPassages[num+3].options=answer
        }
      }
    },
    ToPrev(){
      this.testPassages.map((item,index)=>{
        if(item.show){
          item.show=false;
          this.current = item.num-1
        }
      })
      this.testPassages[this.current-1].show=true;
      this.show=false
      if(this.current==1){
        this.next=true
        this.nextGroup = false
        this.submit=false
      }else{
        this.next=false
        this.nextGroup =true
        this.submit=false
      }
    },
    ToNext(){
      if(this.answerArray[this.current-1]!=''){
        this.answerArray.map((item,index)=>{
          if(index>this.current-1){
           this.answerArray[index] = ''
          }
        })
        this.testPassages.map((item)=>{
          if(item.show){
            item.show=false;
            this.current = item.num+1
          }
          if(item.num==this.current){
            item.show=true
            this.show=true
          }
          // 当前题目为最后一题时显示提交按钮,其他时候显示下一页按钮
          if(this.current==6){
            this.next=false
            this.nextGroup = false
            this.submit=true
          }else{
            this.next=false
            this.nextGroup = true
            this.submit=false
          }
        })
      }else{
        this.$store.commit('showMessage', {
          message:'请按要求选择',
          type: 'error'
        })
      }
    },
    submitDta(){
      // if(this.submitNum==0){
      //   this.submitNum=1
        this.result=''
        this.answerArray.map((item,index)=>{
          if(item){
            this.result+=(index+1)+'$'+item
            if(index<5){
              this.result+='}'
            }
          }else{
            return false
          }
        })
        const options = {
          method: 'POST',
          headers: {
            'content-type': 'application/x-www-form-urlencoded'
          },
          data: qs.stringify({
            submitdata: this.result,
            openId: this.shengyaUser.openid
          }),
          url: '/cob/saveCosBalanceAnswer.do'
        };
        axios(options)
          .then((response)=>{
            if(response.data.result.success){
              let cosBalanceAnswer = response.data
              let shengyaUser = cosBalanceAnswer.data.user
              this.$bus.$emit('play-finish', shengyaUser)
            }else{
              this.$store.commit('showMessage', {
                message: res.data.result.message,
                type: 'error'
              })
            }
          })
          .catch((error)=>{
            console.log(error);
          });
      // }
    }
  }
}
</script>
<style lang="stylus" scoped>
  .default-btn
    margin-top:0.2rem
</style>
